import * as React from 'react';
import parse from 'html-react-parser'

import { requestGet } from '../../../../../../modules/request';
import { ReactTable, redirectToActivity, getExtraSmallColoredIconForActivityClassification, } from '../../../../../Shared/index';
import PreviouslyAssignedTooltip from '../../previouslyAssignedTooltip';

export const UnitTemplateProfileActivityTable = ({ data }) => {
  const { activities } = data;
  const [previouslyAssignedActivityData, setPreviouslyAssignedActivityData] = React.useState(null)

  React.useEffect(() => {
    if(!previouslyAssignedActivityData && activities) {
      const activityIds = JSON.stringify(activities.map(activity => activity.id))
      requestGet(`${window.postbuildEnv.DEFAULT_URL}/teachers/unit_templates/previously_assigned_activities?activity_ids=${activityIds}`, (response) => {
        if(response.previously_assigned_activity_data && Object.keys(response.previously_assigned_activity_data).length) {
          const { previously_assigned_activity_data } = response
          setPreviouslyAssignedActivityData(previously_assigned_activity_data)
        }
      })
    }
  }, [])

  function columnDefinitions() {
    // Student, Date, Activity, Score, Standard, Tool
    return [
      {
        Header: 'Tool',
        maxWidth: 60,
        minWidth: 60,
        accessor: a => a,
        id: 'toolName',
        Cell: ({row}) => getExtraSmallColoredIconForActivityClassification(row.original.classification.id),
      },
      {
        Header: 'Activity',
        accessor: a => a,
        maxWidth: 560,
        minWidth: 560,
        id: 'activityName',
        Cell: ({row}) => {
          // The tooltip triggers on hover of the whole row (see scoped CSS) but
          // stays anchored under the Activity Name, so it lives in this cell only.
          const activityButton = <button className="interactive-wrapper activity-name focus-on-light highlight-on-hover" onClick={() => redirectToActivity(row.original.id)}>{parse(row.original.name)}</button>
          return(
            <span className="quill-tooltip-trigger">
              <span>{activityButton}</span>
              <span className="quill-tooltip-wrapper">
                <span className="quill-tooltip visible" dangerouslySetInnerHTML={{ __html: row.original.tooltipText }} />
              </span>
            </span>
          );
        },
      },
      {
        Header: 'Activity Focus',
        accessor: a => a,
        maxWidth: 240,
        minWidth: 240,
        id: 'conceptName',
        Cell: ({row}) => {
          const { activity_focus_name, activity_focus_category_name } = row.original;
          return(
            <span className="activity-focus-cell">
              {activity_focus_category_name && <span className="focus-category-prefix">{activity_focus_category_name}</span>}
              <span className="focus-name">{activity_focus_name}</span>
            </span>
          );
        },
      },
      {
        Header: 'Target Grade Range',
        accessor: a => a,
        maxWidth: 120,
        minWidth: 120,
        id: 'targetGradeRange',
        Cell: ({row}) => <span className="target-grade-range-cell">{row.original.grade_band_range}</span>,
      },
      {
        Header: 'Previously Assigned',
        accessor: a => a,
        maxWidth: 90,
        minWidth: 90,
        id: 'previouslyAssigned',
        Cell: ({row}) => {
          const { original } = row;
          const { previouslyAssignedActivityData } = original;
          return <PreviouslyAssignedTooltip previouslyAssignedActivityData={previouslyAssignedActivityData} />
        },
      },
      {
        Header: 'Preview',
        accessor: 'id',
        maxWidth: 130,
        minWidth: 130,
        id: 'preview',
        Cell: ({row}) => <button className='quill-button outlined green extra-small focus-on-light' onClick={() => redirectToActivity(row.original.id)} type="button">Preview</button>,
      }
    ];
  };

  const activitiesFormattedForTable = activities.map(a => {
    const formattedActivity = { ...a }
    const divider = "<div class='horizontal-divider'></div>"
    const standardLevelName = a.standard_level_name ? `${divider}<p><b>Standard Level Name: </b><span>${a.standard_level_name}</span></p>` : ''
    const standardName = a.standard.name ? `${divider}<p><b>Standard Name: </b><span>${a.standard.name}</span></p>` : ''
    const gradeBandRange = a.grade_band_range ? `${divider}<p><b>Target Grade Range: </b> <span>${a.grade_band_range}</span></p>` : ''
    const topics = a.topic_names ? `${divider}<p><b>Topics:</b> <span>${a.topic_names.join(', ')}</span></p>` : ''
    const tooltipText = `<h5>${a.name}</h5>${divider}<p><b>Tool:</b> <span>${a.classification.name}</span></p>${standardLevelName}${standardName}${gradeBandRange}${topics}${divider}<p class='tooltip-activity-description'>${a.description}</p>`
    formattedActivity.tooltipText = tooltipText
    formattedActivity.previouslyAssignedActivityData = previouslyAssignedActivityData && previouslyAssignedActivityData[a.id] ? previouslyAssignedActivityData[a.id] : null
    return formattedActivity
  })

  return (
    <ReactTable
      className='unit-template-profile-activities'
      columns={columnDefinitions()}
      data={activitiesFormattedForTable}
      defaultPageSize={activitiesFormattedForTable.length}
    />
  )
}

export default UnitTemplateProfileActivityTable;
